/**
 * Render an element in a DOM container node
 * @param  {Object} element – DOM element.
 * @param  {Object} container – Container element.
 */
export function render(element, container) {
  const node = document.createElement("div");
  node.innerHTML = element.render();
  container.append(node.firstElementChild);
}
